import React, { useState, useEffect } from 'react';
import { isSuperAdmin } from '../utils/userUtils';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import { isAdminAuthorized } from '../utils/userUtils';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';
import DefaultModal from './components/modals/DefaultModal';

function CatmatImport() {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState('');
  const [success, setSuccess] = useState('');
  const [importStats, setImportStats] = useState(null);
  const [user, setUser] = useState(null);
  const [usuarioBind, setUsuarioBind] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // Histórico de importações dinâmico
  const [importHistory, setImportHistory] = useState([]);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    // Validar usuário e permissões
    const userData = localStorage.getItem('user');
    const usuarioBindData = localStorage.getItem('usuarioBind');

    if (!userData || !usuarioBindData) {
      navigate('/');
      return;
    }

    const parsedUser = JSON.parse(userData);
    const parsedUsuarioBind = JSON.parse(usuarioBindData);

    setUser(parsedUser);
    setUsuarioBind(parsedUsuarioBind);

    // manter apenas validação mínima do usuário presente

    loadStats();
    fetchImportHistory();
  }, [token, navigate]);

  // Função para carregar estatísticas dos dados
  const loadStats = async () => {
    try {
      const statsResponse = await axios.get(
        `${API_BASE_URL.CATMAT}/estatisticas`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log('Dados de estatísticas recebidos:', statsResponse.data);
      console.log(
        'ultimaAtualizacao específica:',
        statsResponse.data.ultimaAtualizacao
      );
      setImportStats(statsResponse.data);
    } catch (err) {
      console.error('Erro ao carregar estatísticas:', err);
      // Não exibe erro se falhar ao carregar estadísticas
    }
  };

  const fetchImportHistory = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL.CATMAT}/import-log?tipoImportacao=CATMAT`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setImportHistory(response.data || []);
    } catch (err) {
      setImportHistory([]);
    }
  };

  const handleFullImport = async () => {
    if (!isSuperAdmin(user)) {
      setErrorMessage('Acesso negado. Você não possui permissão para executar esta ação.');
      setShowErrorModal(true);
      return;
    }

    setIsLoading(true);
    setSuccess('');
    setProgress('Iniciando importação completa...');

    try {
      const response = await axios.post(
        `${API_BASE_URL.CATMAT}/importar-todos`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 300000, // 5 minutos de timeout
        }
      );

      if (response.data.success) {
        setSuccess(
          `Importação completa realizada com sucesso! ${response.data.totalImportados} registros importados.`
        );
        // Recarregar estatísticas
        loadStats();
      } else {
        setErrorMessage(
          response.data.message || 'Erro desconhecido na importação'
        );
        setShowErrorModal(true);
      }
    } catch (err) {
      console.error('Erro na importação completa:', err);
      if (err.code === 'ECONNABORTED') {
        setErrorMessage(
          'Timeout na operação. A importação pode ainda estar em andamento.'
        );
      } else {
        setErrorMessage(
          err.response?.data?.message || 'Erro ao executar importação completa'
        );
      }
      setShowErrorModal(true);
    } finally {
      setIsLoading(false);
      setProgress('');
    }
  };

  const refreshStats = () => {
    loadStats();
  };

  const formatDateTime = dateTime => {
    if (!dateTime) return 'N/A';

    console.log('Data recebida para formatação:', dateTime, typeof dateTime);

    try {
      // Se for string, tenta fazer o parse
      const date = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;

      // Verifica se a data é válida
      if (isNaN(date.getTime())) {
        console.log('Data inválida:', dateTime);
        return 'Data inválida';
      }

      return date.toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    } catch (error) {
      console.error('Erro ao formatar data:', error, dateTime);
      return 'Erro na data';
    }
  };

  const formatNumber = number => {
    if (typeof number !== 'number') return number;
    return number.toLocaleString('pt-BR');
  };

  if (!user && !showErrorModal) {
    return (
      <Layout>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm">
                <div className="card-body text-center">
                  <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">Acesso Negado</h4>
                    <p>
                      Você não possui permissão para acessar esta
                      funcionalidade.
                    </p>
                    <p className="mb-0">
                      Apenas administradores autorizados podem importar dados
                      CATMAT.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Importação CATMAT" icon="bi-download" closeRoute="/home" backButton={false} />
        <PageContent>
        {isSuperAdmin(user) && (
          <Toolbar
            actions={[
              { key: 'import', label: isLoading ? 'Importando...' : 'Importar Dados', icon: isLoading ? 'fas fa-spinner fa-spin' : 'fas fa-download', variant: 'primary', disabled: isLoading, onClick: handleFullImport },
              { key: 'refresh', label: 'Atualizar Estatísticas', icon: 'fas fa-refresh', variant: 'outline-info', disabled: isLoading, onClick: refreshStats },
            ]}
          />
        )}

      {/* Histórico de Importações */}
      <TableContainer className="table-responsive mb-2">
        <h5 className="text-info fw-bold mb-2">
          <i className="fas fa-history me-2"></i>
          Histórico de Importações
        </h5>
        <table className="table table-bordered table-sm table-custom-radius">
          <TableHeader columns={[
            { label: 'Data/Hora' },
            { label: 'Tipo' },
            { label: 'Total Importado' },
            { label: 'Usuário' },
            { label: 'Detalhes' },
          ]} />
          <tbody>
            {importHistory.length > 0 ? (
              importHistory.map((log, idx) => (
                <tr key={idx}>
                  <td>{formatDateTime(log.dataHora)}</td>
                  <td>{log.tipoImportacao}</td>
                  <td>{formatNumber(log.totalImportado)}</td>
                  <td>{log.usuario}</td>
                  <td>{log.detalhes}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  Nenhuma importação realizada ainda
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>

      {/* Alertas e progresso */}
      {success && (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          <i className="fas fa-check-circle me-2"></i>
          {success}
          <button
            type="button"
            className="btn-close"
            onClick={() => setSuccess('')}
          ></button>
        </div>
      )}
      {progress && (
        <div className="alert alert-info" role="alert">
          <i className="fas fa-spinner fa-spin me-2"></i>
          {progress}
        </div>
      )}

      {/* Modal de Erro */}
      <DefaultModal
        show={showErrorModal}
        type="error"
        message={errorMessage}
        onClose={() => setShowErrorModal(false)}
      />
        </PageContent>
      </ResponsiveShadow>
    </Layout>
  );
}

export default CatmatImport;
